
/* global YT  */

(function($) {
    $.fn.youTubePlayer = function(opt) {
        return this.each(function() {
            var me = this, $me = $(this),
                attrId = $me.attr('id'),
                id = $me.data('movie');
            if (!id) return;
            
            me.resize = function() {
                var w = $('#' + attrId).parent().width(),
                    h = w / me.ratio;
                me.player.setSize(w, h);
            };
            me.player = new YT.Player($me.attr('id'), {
                    enablejsapi: 1,
                    loop: 1,
                    listType: 'playlist',
                    list: id,
                    videoId: id,
                    playerVars: {
                        loop: 1,
                        rel: 0,
                        showinfo: 0
                    },
                    events: {
                        onReady: () => {
                            me.ratio = $('#' + attrId).width() / $('#' + attrId).height();
                            me.resize();
                            $('#' + attrId).parent().addClass('show');
                        }
                    }
                });
            $(document).on('resizeResponsive', () => { me.resize(); });
            return me;
        });
    };
    $(document).ready(function() {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
})(jQuery);
function onYouTubeIframeAPIReady() { // eslint-disable-line 
    $('.youtube-player').youTubePlayer();
}
